import { createApp } from 'vue';
const TEMPLATE_TO_RENDER_COMPONENT = '<local-component />';

const create = (localComponent) => {
  const app = createApp({
    components: {
      localComponent
    },
    template: TEMPLATE_TO_RENDER_COMPONENT
  });

  const mountedComponent = app.mount(document.createElement('div'));

  return mountedComponent.$el.outerHTML;
};

export default {
  create
};
